import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'shards-react';

const mapState = (state) => ({
	user: state.firebase.profile,
	firestore: state.firestore,
	firebase: state.firebase
});

class Test extends Component {
	static contextTypes = {
		store: PropTypes.object.isRequired
	};

	componentDidMount() {
		const { firestore } = this.props;
		let complaints = firestore.get('complaints');
		console.log(complaints);
	}
	render() {
		return (
			<Container className="my-2">
				<h2>Test</h2>
			</Container>
		);
	}
}

export default connect(mapState, null)(Test);
